
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Item } from '@view/a-pedido-cargar/controlador-pedido';
    import { ControladorInterfaz } from '@view/a-pedido-cargar/controlador';
    import { Articulo } from '@/__env/lib/Articulos';


    @Component( {
        name: "Celda",
        props: {},
        components: {
        }
    } )
    export default class Celda extends Vue
    {
        @Prop() Controlador: ControladorInterfaz;
        @Prop() Item: Item;
        public Articulo: Articulo = new Articulo();

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );

        }

        mounted()
        {
            this.Articulo = this.Item.Articulo;
            this.Eventos.push( this.Controlador.EdicionPedido.NuevoItem.onEditarItem.subscribe( ( item, index, event ) =>
            {
                if ( item && item.Articulo && item.Articulo.Id == this.Articulo.Id )
                {
                    this.Articulo = item.Articulo;
                    this.Refrescar();
                }

            } ) );

        }

        public Refresh: boolean = true;
        Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => this.Refresh = true );
        }

    }
